import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { 
    MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, MatSelectModule, MatToolbarModule,
    MatDialogModule, MatSnackBarModule
} from '@angular/material';

import { FuseSharedModule } from '@fuse/shared.module';

import { FinanzasCuentasComponent } from "app/main/gastos/finanzas/cuentas/cuentas.component";
import { FinanzasCuentasService } from "app/main/gastos/finanzas/cuentas.service";
import { FuseConfirmDialogModule, FuseSidebarModule } from '@fuse/components';
import { CuentaFormDialogComponent } from './cuenta-form/cuenta-form.component';
import { AuthGuard } from 'app/core/auth.guard';

const routes = [
    {
        path     : 'cuentas',
        canActivate: [AuthGuard],
        component: FinanzasCuentasComponent,
        resolve  : {
            academy: FinanzasCuentasService
        }
    },
    {
        path      : '**',
        redirectTo: 'cuentas'
    }
];

@NgModule({
    declarations: [
        FinanzasCuentasComponent,
        CuentaFormDialogComponent
    ],
    imports     : [
        RouterModule.forChild(routes),

        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatToolbarModule,
        MatDialogModule,
        MatSnackBarModule,

        FuseSharedModule,
        FuseSidebarModule,
        FuseConfirmDialogModule
    ],
    exports: [
        MatDialogModule
    ],
    providers   : [
        FinanzasCuentasService,
        CuentaFormDialogComponent
    ],
    entryComponents: [
        CuentaFormDialogComponent
    ]
})
export class FinanzasModule
{
}
